import * as Network from "expo-network";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";

const fetchNetworkInfo = async (): Promise<DiagnosticItem[]> => {
  const networkState = await Network.getNetworkStateAsync();
  let ipAddress = "0.0.0.0";

  ipAddress = await Network.getIpAddressAsync();

  if (ipAddress === "0.0.0.0") {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    ipAddress = data.ip || "0.0.0.0";
  }

  return [
    {
      id: "networkType",
      name: "Network Type",
      value: networkState?.type || "Unknown",
      status: networkState?.isConnected
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "isInternetReachable",
      name: "Internet Reachable",
      value: networkState?.isInternetReachable ? "Yes" : "No",
      status: networkState?.isInternetReachable
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "ipAddress",
      name: "IP Address",
      value: ipAddress || "Unknown",
      status: ipAddress ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
  ];
};

export default fetchNetworkInfo;
